import React from 'react';
import './Badges.css';

/* Badge semántico de ESTADO (F2, ESTANDAR §7: estados mediante chips de color).
   Cinco variantes de los tokens de estado + dos estados de pedido propios.
   Es INFORMACIÓN, no acción: nunca lleva onClick (brief §8 — la semántica
   visual distingue qué se pulsa y qué se lee). */
const VARIANTS = new Set(['success', 'warning', 'error', 'info', 'neutral', 'en-espera', 'reembolsado']);

export default function StatusBadge({ variant = 'neutral', icon = null, className = '', children }) {
  const v = VARIANTS.has(variant) ? variant : 'neutral';
  return (
    <span className={`ui-status-badge ui-status-badge--${v}${className ? ` ${className}` : ''}`}>
      {icon && <span className="ui-status-badge-icon" aria-hidden="true">{icon}</span>}
      {children}
    </span>
  );
}
